export default "__VITE_ASSET__BMs8rqHI__"